import './SiteBlock.scss';

import React from 'react';
import { classnames } from '@bem-react/classnames';

import { cn } from '../../utils/bem';
import { useBreakpoints } from '@dataartdev/uikit/__internal__/cjs-src/components/Grid/useBreakpoints';
import { GridPropGap } from '@dataartdev/uikit/Grid';

export const cnSiteBlock = cn('SiteBlock');

type Breakpoint = {
  sideGap?: number | string;
  topGap?: number | string;
  bottomGap?: number | string;
};

type BreakpointsProps = {
  mobile?: Breakpoint;
  tablet?: Breakpoint;
  desktop?: Breakpoint;
};

type Props = {
  id?: string;
  children?: React.ReactNode;
  sideGap?: string;
  topGap?: GridPropGap;
  bottomGap?: GridPropGap;
  className?: string;
  breakpoints?: BreakpointsProps;
  useMargin?: boolean;
  view?: string;
};

export const SiteBlock: React.FC<Props> = ({
  children,
  topGap,
  bottomGap,
  className,
  breakpoints,
  useMargin,
  id,
  sideGap,
  view,
}) => {
  const breakpointsCn = useBreakpoints(cnSiteBlock, breakpoints);

  return (
    <div
      className={classnames(
        cnSiteBlock({
          topGap,
          bottomGap,
          useMargin,
          sideGap,
          view,
        }),
        breakpointsCn,
        className
      )}
      id={id}
    >
      {children}
    </div>
  );
};
